import {appendQueryString, getCookie} from "@pg-mono/request";

/**
 * Passes the RP cookie consent to the KM app, so the user does not have to accept it again after a cross-domain jump.
 * No-op on the server - `getCookie` reads `document.cookie`.
 */
export const appendCookieConsent = (url: string): string => {
    if (typeof document === "undefined") {
        return url;
    }

    const cookieConsent = getCookie("CookieConsent");

    return cookieConsent ? appendQueryString(url, {cookieConsent}) : url;
};
import {appendQueryString, getCookie} from "@pg-mono/request";

/**
 * Passes the RP cookie consent to the KM app, so the user does not have to accept it again after a cross-domain jump.
 * No-op on the server - `getCookie` reads `document.cookie`.
 */
export const appendCookieConsent = (url: string): string => {
    if (typeof document === "undefined") {
        return url;
    }

    const cookieConsent = getCookie("CookieConsent");

    return cookieConsent ? appendQueryString(url, {cookieConsent}) : url;
};
